module.exports = __webpack_public_path__ + "public/Icons/unactiveIcon.svg?39d99bdc";